module.exports = __webpack_public_path__ + "img/再见.087eaf16.gif";